import * as types from "./pmt_actionTypes";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { baseURL } from "../../BaseURL";
import { getToataldataCount } from "../action";
import { getToatalPages } from "../subscriptionServices/sb_action";

let headerAuth = HeaderAuthentication.getRequestOptions;
// #region storing data to reducer
const getPaymentData = (payment_data) => ({
    type: types.get_payment_data,
    payload: payment_data
})
const getPaymentHistory = (payment_history) => ({
    type: types.get_payment_history,
    payload: payment_history
})
const getHistoryToatalCount = (history_total) => ({
    type: types.get_history_total,
    payload: history_total
})
const getHistoryPages = (history_pages) => ({
    type: types.get_history_total_pages,
    payload: history_pages
})
// #endregion

// #region api service call fucntions
export const loadPaymentData = (params) => {
    return function (dispatch, getState) {
        return fetch(`${baseURL}/Users/get_payment_data?page=${params.page}&page_size=${params.page_size}&from_date=${params.from_date}&to_date=${params.to_date}&plan=${params.plan}&search_text=${params.search_text}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    // dispatch(getRecentActivities(resp.activities))
                    if (params.page > 1) {
                        const state = getState();
                        const currentdata = state.paymentdata?.payment_data || [];

                        const updatedSubscriptions = [...currentdata, ...resp.user_payments];
                        dispatch(getPaymentData(updatedSubscriptions));
                    } else {
                        dispatch(getPaymentData(resp.user_payments));
                    }
                    dispatch(getToataldataCount(resp.total_unique_users))
                    dispatch(getToatalPages(resp.total_pages))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const loadPaymentHistory = (params) => {
    return function (dispatch, getState) {
        return fetch(`${baseURL}/Users/paymnet_history?page=${params.page}&page_size=${params.page_size}&from_date=${params.from_date}&to_date=${params.to_date}&user_id=${params.user_id}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    // dispatch(getRecentActivities(resp.activities))
                    if (params.page > 1) {
                        const state = getState();
                        const currentdata = state.paymentdata?.payment_history || [];

                        const updatedSubscriptions = [...currentdata, ...resp.payment_history];
                        dispatch(getPaymentHistory(updatedSubscriptions));
                    } else {
                        dispatch(getPaymentHistory(resp.payment_history));
                    }
                    dispatch(getHistoryToatalCount(resp.total_records))
                    dispatch(getHistoryPages(resp.total_pages))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion